import { schema, types } from 'papr'

const ALLOWED_TYPES = [
	'response.upvoted',
	'response.downvoted',
	'post.upvoted',
	'post.downvoted',
	'post.responded',
	'response.replied',
	'story.written',
	'question.asked',
	'link.shared',
	'poll.participated',
	'amaQuestion.asked',
	'amaQuestion.upvoted',
	'amaQuestion.answered',
]

export const userActivitySchema = schema(
	{
		type: types.string({ required: true, enum: ALLOWED_TYPES }),
		post: types.objectId(),
		ama: types.object({
			name: types.string(),
			cuid: types.string(),
			slug: types.string(),
		}),
		response: types.string(),
		responseStamp: types.string(),
		reply: types.string(),
		user: types.objectId(),
		url: types.string(),
		subjectUsername: types.string(),
		subjectName: types.string(),
		reason: types.string(),
		itemText: types.string(),
		itemLink: types.string(),
		itemType: types.string(),
		dateAdded: types.date(),
		isActive: types.boolean(),
	},
	{
		defaults: {
			isActive: true,
		},
	},
)

export type UserActivityDocument = (typeof userActivitySchema)[0]
export type UserActivitySchemaOptions = (typeof userActivitySchema)[1]
